import React, { useState, useEffect } from 'react';
import {
    Box, Typography, TextField, MenuItem, Paper, Button, Dialog, DialogActions,
    DialogContent, DialogTitle, IconButton, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';
import StockMercDetails from './StockMercDetails';  // importando o novo componente

const Stockmercadorias = () => {
    const [openFornecedorDialog, setOpenFornecedorDialog] = useState(false);
    const [openArtigoDialog, setOpenArtigoDialog] = useState(false);
    const [openImportDialog, setOpenImportDialog] = useState(false);
    const [fornecedores, setFornecedores] = useState([]);
    const [novoFornecedor, setNovoFornecedor] = useState({ nome: '', tipo: 'local' });
    const [novoArtigo, setNovoArtigo] = useState({
        nome: '',
        tipo: '',
        referencia: '',
        stock_minimo: '',
        stock_maximo: '',
        quantidade_por_caixa: '',
        certificado: '',
        fornecedores: []
    });
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const user = JSON.parse(localStorage.getItem('user'));

    // Estados para a importação
    const [importSearchTerm, setImportSearchTerm] = useState('');
    const [importResults, setImportResults] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);

    const apiBaseURL = 'https://plasticemployers.duckdns.org';

    useEffect(() => {
        fetchFornecedores();
    }, []);

    useEffect(() => {
        if (openImportDialog) {
          const delayDebounceFn = setTimeout(() => {
            handleImportSearch();
          }, 300); // 300ms de atraso
          return () => clearTimeout(delayDebounceFn);
        }
    }, [importSearchTerm, page, rowsPerPage, openImportDialog]);

    const isAdmin = user && user.seccao === 'Admin';

    const fetchFornecedores = async () => {
        try {
            const response = await axios.get('/api/fornecedores/');
            setFornecedores(response.data);
        } catch (error) {
            console.error('Erro ao buscar fornecedores:', error);
        }
    };

    const handleAddFornecedor = async () => {
        try {
            const response = await axios.post('/api/fornecedores/', novoFornecedor);
            setFornecedores([...fornecedores, response.data]);
            setOpenFornecedorDialog(false);
            setSnackbarMessage('Fornecedor criado com sucesso!');
            setSnackbarOpen(true);
        } catch (error) {
            console.error('Erro ao criar fornecedor:', error);
            setSnackbarMessage('Erro ao criar fornecedor.');
            setSnackbarOpen(true);
        }
    };

    const handleAddArtigo = async () => {
        const payload = {
            ...novoArtigo,
            stock_minimo: novoArtigo.stock_minimo ? parseInt(novoArtigo.stock_minimo, 10) : 0,
            stock_maximo: novoArtigo.stock_maximo ? parseInt(novoArtigo.stock_maximo, 10) : 0,
            quantidade_por_caixa: novoArtigo.quantidade_por_caixa ? parseInt(novoArtigo.quantidade_por_caixa, 10) : 0,
        };
        try {
            const response = await axios.post(`${apiBaseURL}/api/artigos-mercadoria/`, payload);
            setOpenArtigoDialog(false);
            setSnackbarMessage('Artigo criado com sucesso!');
            setSnackbarOpen(true);
        } catch (error) {
            console.error('Erro ao criar artigo:', error.response?.data || error);
            setSnackbarMessage('Erro ao criar artigo.');
            setSnackbarOpen(true);
        }
    };

    // Função para buscar os artigos via API externa
    const handleImportSearch = async () => {
        try {
            const response = await axios.get(`${apiBaseURL}/api/artigos-merc/`, {
                params: { 
                    search: importSearchTerm,
                    page: page + 1, // considerando que a API começa em 1
                    limit: rowsPerPage 
                }
            });
            // Supondo que a resposta possua { results: [...], totalCount: número }
            setImportResults(response.data.results);
            setTotalCount(response.data.totalCount);
        } catch (error) {
            console.error('Erro ao buscar artigos:', error);
            setSnackbarMessage('Erro ao buscar artigos.');
            setSnackbarOpen(true);
        }
    };

    // Função chamada ao importar um artigo da lista
    const handleImportItem = (item) => {
        setNovoArtigo({ 
            ...novoArtigo, 
            referencia: item.ref, 
            nome: item.design 
        });
        setOpenImportDialog(false);
        setOpenArtigoDialog(true);
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', p: 3 }}>
            <Typography variant="h5" sx={{ mb: 3 }}>Gestão de Mercadorias</Typography>
            {isAdmin && (
                <Paper sx={{ p: 3, mt: 3, display: 'flex', gap: 2 }}>
                    <Button variant="contained" color="primary" onClick={() => setOpenFornecedorDialog(true)}>
                        Criar Fornecedor
                    </Button>
                    <Button variant="contained" color="success" onClick={() => setOpenArtigoDialog(true)}>
                        Criar Artigo
                    </Button>
                    <Button variant="contained" color="info" onClick={() => setOpenImportDialog(true)}>
                        Importar
                    </Button>
                </Paper>
            )}
            {/* Diálogo para criar fornecedor */}
            <Dialog open={openFornecedorDialog} onClose={() => setOpenFornecedorDialog(false)}>
                <DialogTitle>Criar Fornecedor</DialogTitle>
                <DialogContent>
                    <TextField
                        label="Nome"
                        fullWidth
                        sx={{ mt: 2 }}
                        value={novoFornecedor.nome}
                        onChange={(e) => setNovoFornecedor({ ...novoFornecedor, nome: e.target.value })}
                    />
                    <TextField
                        select
                        label="Tipo"
                        fullWidth
                        sx={{ mt: 2 }}
                        value={novoFornecedor.tipo}
                        onChange={(e) => setNovoFornecedor({ ...novoFornecedor, tipo: e.target.value })}
                    >
                        <MenuItem value="local">Local</MenuItem>
                        <MenuItem value="internacional">Internacional</MenuItem>
                    </TextField>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenFornecedorDialog(false)}>Cancelar</Button>
                    <Button onClick={handleAddFornecedor} color="primary">Criar</Button>
                </DialogActions>
            </Dialog>
            {/* Diálogo para criar artigo */}
            <Dialog open={openArtigoDialog} onClose={() => setOpenArtigoDialog(false)}>
                <DialogTitle>Criar Artigo</DialogTitle>
                <DialogContent>
                    <TextField
                        label="Nome"
                        fullWidth
                        sx={{ mt: 2 }}
                        value={novoArtigo.nome}
                        onChange={(e) => setNovoArtigo({ ...novoArtigo, nome: e.target.value })}
                    />
                    <TextField
                        label="Tipo"
                        fullWidth
                        sx={{ mt: 2 }}
                        value={novoArtigo.tipo}
                        onChange={(e) => setNovoArtigo({ ...novoArtigo, tipo: e.target.value })}
                    />
                    <TextField
                        label="Referência"
                        fullWidth
                        sx={{ mt: 2 }}
                        value={novoArtigo.referencia}
                        onChange={(e) => setNovoArtigo({ ...novoArtigo, referencia: e.target.value })}
                    />
                    <TextField
                        label="Stock Mínimo"
                        fullWidth
                        sx={{ mt: 2 }}
                        type="number"
                        value={novoArtigo.stock_minimo}
                        onChange={(e) => setNovoArtigo({ ...novoArtigo, stock_minimo: e.target.value })}
                    />
                    <TextField
                        label="Stock Máximo"
                        fullWidth
                        sx={{ mt: 2 }}
                        type="number"
                        value={novoArtigo.stock_maximo}
                        onChange={(e) => setNovoArtigo({ ...novoArtigo, stock_maximo: e.target.value })}
                    />
                    <TextField
                        label="Quantidade por Caixa"
                        fullWidth
                        sx={{ mt: 2 }}
                        type="number"
                        value={novoArtigo.quantidade_por_caixa}
                        onChange={(e) => setNovoArtigo({ ...novoArtigo, quantidade_por_caixa: e.target.value })}
                    />
                    <TextField
                        label="Certificado"
                        fullWidth
                        sx={{ mt: 2 }}
                        value={novoArtigo.certificado}
                        onChange={(e) => setNovoArtigo({ ...novoArtigo, certificado: e.target.value })}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenArtigoDialog(false)}>Cancelar</Button>
                    <Button onClick={handleAddArtigo} color="success">Criar</Button>
                </DialogActions>
            </Dialog>
            {/* Diálogo para importação de artigos */}
            <Dialog open={openImportDialog} onClose={() => setOpenImportDialog(false)} fullWidth>
                <DialogTitle>Importar Artigo</DialogTitle>
                <DialogContent>
                    <TextField
                        label="Pesquise a referencia aqui"
                        fullWidth
                        sx={{ mt: 2 }}
                        value={importSearchTerm}
                        onChange={(e) => {
                            setImportSearchTerm(e.target.value);
                            setPage(0); // reseta para a primeira página ao mudar o termo
                        }}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                handleImportSearch();
                            }
                        }}
                    />
                    <TableContainer sx={{ mt: 2 }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Ref</TableCell>
                                    <TableCell>Design</TableCell>
                                    <TableCell>Stock</TableCell>
                                    <TableCell>Ações</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {importResults.map((result) => (
                                    <TableRow key={result.ref}>
                                        <TableCell>{result.ref}</TableCell>
                                        <TableCell>{result.design}</TableCell>
                                        <TableCell>{result.stock}</TableCell>
                                        <TableCell>
                                            <Button variant="contained" color="primary" onClick={() => handleImportItem(result)}>
                                                Importar
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        component="div"
                        count={totalCount}
                        page={page}
                        onPageChange={(event, newPage) => setPage(newPage)}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={(event) => {
                            setRowsPerPage(parseInt(event.target.value, 10));
                            setPage(0);
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenImportDialog(false)}>Cancelar</Button>
                </DialogActions>
            </Dialog>
            {/* Snackbar para exibir mensagens */}
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={() => setSnackbarOpen(false)}
                message={snackbarMessage}
            />
            {/* Novo Paper para StockMercDetails */}
            <StockMercDetails />
        </Box>
    );
};

export default Stockmercadorias;
